'use client';

import { type FC } from 'react';
import { Text, Pill, Button, Flex } from '@/_components';
import styles from './WorkflowsTable.module.css';
import type { WorkflowsTableProps } from './WorkflowsTable.types';

export const WorkflowsTable: FC<WorkflowsTableProps> = ({
  workflows,
  onEdit,
  onDelete,
}) => {
  if (!workflows || workflows.length === 0) {
    return (
      <Text className={styles.noWorkflowsText}>No workflows to display.</Text>
    );
  }

  return (
    <div className={styles.tableContainer}>
      <table className={styles.table}>
        <thead>
          <tr>
            <th className={styles.th}>Name</th>
            <th className={styles.th}>Status</th>
            <th className={styles.th}>Last Modified</th>
            <th className={styles.th}>Actions</th>
          </tr>
        </thead>
        <tbody>
          {workflows.map((workflow) => (
            <tr key={workflow.id}>
              <td className={styles.td}>
                <Text fontWeight="medium">{workflow.name}</Text>
              </td>
              <td className={styles.td}>
                <Pill
                  intent={workflow.status === 'Active' ? 'success' : 'default'}
                  label={workflow.status}
                />
              </td>

              <td className={styles.td}>
                <Text color="secondary">{workflow.lastModified}</Text>
              </td>
              <td className={styles.td}>
                <Flex gap={2} isYCentered>
                  <Button
                    size="small"
                    intent="ghost"
                    iconLeft="pencil"
                    onClick={() => onEdit(workflow.id)}
                    value="Edit"
                  />
                  <Button
                    size="small"
                    intent="danger-ghost"
                    iconLeft="trash"
                    onClick={() => onDelete?.(workflow.id)}
                    value="Delete"
                  />
                </Flex>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
